import type { PriceRangeFilter } from '$gql/storefront/schemas';
import { derived, get } from 'svelte/store';
import { baseFormatCurrency } from '../currency';
import { lang } from '$lib/lang';
import { t } from '$lib/i18n';

const gtePrepend = 'gte' as const;
const ltePrepend = 'lte' as const;
const separator = '+' as const;

export const encodePriceRange = ({ min, max }: PriceRangeFilter) => {
  const gte = min ? gtePrepend + min : undefined;
  const lte = max ? ltePrepend + max : undefined;
  return encodeURIComponent([gte, lte].filter((p) => typeof p !== 'undefined').join(separator));
};

export const decodePriceRange = (value: string): PriceRangeFilter | undefined => {
  const decoded = decodeURIComponent(value).split(separator);

  if (decoded.length > 0) {
    let min: number | undefined = undefined;
    let max: number | undefined = undefined;

    decoded.forEach((p) => {
      if (p.includes(gtePrepend)) {
        const tmp = p.replace(gtePrepend, '');
        min = !isNaN(+tmp) ? +tmp : undefined;
      } else if (p.includes(ltePrepend)) {
        const tmp = p.replace(ltePrepend, '');
        max = !isNaN(+tmp) ? +tmp : undefined;
      }
    });

    return { min, max };
  }
};

export const parsePriceRangeLabel = derived(lang, ($lang) => {
  return ({ min, max }: PriceRangeFilter, currency: string) => {
    if (min && max) {
      return `${baseFormatCurrency($lang, currency, min)}-${baseFormatCurrency(
        $lang,
        currency,
        max
      )}`;
    } else if (min) {
      return get(t)('filters.price-over', {
        value: baseFormatCurrency($lang, currency, min)
      });
    } else if (max) {
      return get(t)('filters.price-under', {
        value: baseFormatCurrency($lang, currency, max)
      });
    }
  };
});
